<template>
  <Breadcrumbs
      title="Edit Order Request Schedule"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Order Request Schedule', path: '/order-request-schedule' },
      { label: 'Edit Order Request Schedule', path: '/order-request-schedule-edit' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editOrderRequest/>
    </div>
  </div>
</template>

<script>
import editOrderRequest from "@/pages/stock/order_request_schedule/posheduleEditForm.vue";

export default {
  name: 'indexList',
  components: {
    editOrderRequest,
  },
}
</script>
